module.exports = __webpack_public_path__ + "img/money_active.f132f1c1.svg";